<template>
  <div class="politicas-wrapper">
    <h1 class="titulo">Políticas de Compra, Apartado y Envío</h1>

    <p class="intro">
      En <strong>Distribuidora Maxica</strong> nos esforzamos por brindarte una
      experiencia de compra clara, segura y confiable. A continuación
      encontrarás nuestras políticas generales.
    </p>

    <h2 class="seccion">Apartados</h2>
    <ul>
      <li>Los productos pueden ser apartados por <strong>4 días</strong>.</li>
      <li>
        Si necesitas más tiempo, puedes realizar un
        <strong>abono parcial</strong>.
      </li>
      <li>
        Pasados <strong>5 días</strong> sin abono ni retiro, se libera y repone
        la mercancía.
      </li>
    </ul>

    <h2 class="seccion">Envíos</h2>
    <ul>
      <li>
        Realizamos envíos a todo el país bajo la modalidad de
        <strong>pago contra entrega</strong>.
      </li>
      <li>
        Es obligatorio <strong>grabar video al destapar</strong> el paquete para
        reportar cualquier novedad. Sin video, no se responde por errores o
        faltantes.
      </li>
      <li>
        Antes de consignar, <strong>verifica el número de cuenta</strong>, ya
        que puede rotar.
      </li>
    </ul>

    <h2 class="seccion">Facturación</h2>
    <ul>
      <li>
        Antes de retirar tu pedido o solicitar envío, solicita la
        <strong>factura</strong> y espera confirmación de que el pedido está
        listo.
      </li>
    </ul>

    <h2 class="seccion">Cambios y Garantías</h2>
    <ul>
      <li><strong>No se hacen devoluciones</strong> por cambios de opinión.</li>
      <li>
        Las prendas <strong>no tienen garantía</strong>. Solo se aceptan cambios
        si tienen defectos de fábrica y no han sido usadas.
      </li>
      <li><strong>Los bolsos no tienen garantía ni cambio.</strong></li>
      <li>
        Prendas íntimas, ropa de bebé, tallas únicas y bolsos
        <strong>no tienen cambio.</strong>
      </li>
      <li>
        Los jeans se cambian <strong>solo si no se ha abierto el ojal</strong>.
      </li>
      <li>
        Los cambios se realizan únicamente por
        <strong>una talla más o menos</strong>, no por otra referencia.
      </li>
    </ul>

    <h2 class="seccion">Punto físico</h2>
    <p>
      <strong>Dirección:</strong> Calle 37 #7-66, Barrio Alfonso López,
      Bucaramanga, Santander
    </p>
    <p><strong>Teléfono:</strong> 312 5798515</p>

    <h2 class="seccion">Recomendaciones finales</h2>
    <ul>
      <li>Verifica tu mercancía al recibirla o recogerla en tienda.</li>
      <li>Guarda tu factura como comprobante de compra.</li>
      <li>En caso de reclamos, envía fotos o videos claros como evidencia.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PoliticasMaxica",
};
</script>

<style scoped>
.politicas-wrapper {
  max-width: 960px;
  margin: 54px auto 2rem;
  padding: 1.5rem;
  font-family: "Segoe UI", sans-serif;
  line-height: 1.7;
}

.titulo {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1.2rem;
  color: #111;
}

.intro {
  font-size: 1rem;
  margin-bottom: 1.6rem;
  color: #333;
}

.seccion {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 0.6rem;
  color: #1b365d;
}

ul {
  padding-left: 1.2rem;
  margin-top: 0.4rem;
}

ul li {
  margin-bottom: 0.5rem;
  color: #444;
  font-size: 0.95rem;
}

p {
  font-size: 0.95rem;
  color: #444;
  margin-bottom: 0.6rem;
}
</style>
